import { render, staticRenderFns } from "./AuthorizationToolbarItem.vue?vue&type=template&id=9b9d153e&scoped=true"
import script from "./AuthorizationToolbarItem.vue?vue&type=script&lang=js"
export * from "./AuthorizationToolbarItem.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationToolbarItem.vue?vue&type=style&index=0&id=9b9d153e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9d153e",
  null
  
)

export default component.exports